import fieldTypes from './field-types';

// formik requires initial values for all form fields
// these definitions set initial values for our element types

export default {
  [fieldTypes.ADDRESS]: () => ({
    address1: '',
    address2: '',
    city: '',
    postcode: '',
  }),
  [fieldTypes.DATE_OF_BIRTH]: () => ({
    day: '',
    month: '',
    year: '',
  }),
  [fieldTypes.CHECKBOXES]: (field) =>
    field.options && field.options.length > 1 ? [] : false,
  /**
   * If the default value is present as an option return it, otherwise, return
   * null. This ensures that invalid default values aren't sent to the server.
   */
  [fieldTypes.DROPDOWN]: (field) =>
    field.options &&
    field.options.map((o) => o.value).find((v) => v === field.defaultValue)
      ? field.defaultValue
      : '',
  [fieldTypes.FILE_UPLOAD]: () => ({
    files: [],
    redaction: false,
  }),
};
